<template>
  <div class="content-wrapper" style="padding: 1rem">
    <div class="col-12 mb-primary" align="center">
      <div
        class="card card-with-shadow border-0 h-100 card-content"
        align="left"
      >
        <!-- Banner -->
        <div class="card-header p-primary bg-transparent text-left">
          <!-- <div
            class="banner"
            :style="{
              'background-image': 'url(' + urlGenerator(inquiryFormBanner) + ')',
            }"
          ></div> -->
          <img
            :src="urlGenerator(inquiryFormBanner)"
            alt="Banner"
            class="banner mb-3"
          /><br />
          <div align="center">
            <h2 class="text-inquiry-form">INQUIRY FORM</h2>
          </div>
          <!-- <p class="card-text m-0 text-center">
						Our Active, interactive and creative programs and
						interactive Mandarin Chinese language clases for young
						children starting 3 years old. We offer face to face
						(onsite) in selected locations, online and/or hybrid.
					</p>
					<p class="card-text m-0 text">
						Please complete the details bellow and we will be in
						touch with class options and availability.
					</p> -->
          <!-- <p class="card-text m-0 text-center">
						{{ inquiryFormDescription }}
					</p> -->
        </div>

        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
          <form
            ref="form"
            data-url="/inquiry"
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            @submit.prevent="handleSubmit"
          >
            <div class="row">
              <div class="col-lg-12">
                <div class="container-title-page">
                  <div class="header-title-page">Parents Information</div>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Parent Name -->
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label
                    >Parent Full Name
                    <span class="required-star">*</span></label
                  >
                  <app-input
                    type="text"
                    v-model="inquiry[0].parent_first_name"
                    placeholder="Parent Full Name"
                    name="parent_first_name"
                    required
                  />
                </div>
              </div>
              <!-- <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label
                    >Parent Last Name
                    <span class="required-star">*</span></label
                  >
                  <app-input
                    type="text"
                    v-model="inquiry[0].parent_last_name"
                    placeholder="Parent Name"
                    name="parent_last_name"
                    required
                  />
                </div>
              </div> -->
              <!-- Mobile/WhatsApp Number -->
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label for="inputs_mobile_number">
                    Mobile Number
                    <span class="required-star">*</span>
                  </label>
                  <app-input
                    id="inputs_mobile_number"
                    type="tel-input"
                    v-model="inquiry[0].mobile_number"
                    placeholder="Mobile/WhatsApp Number"
                    @dial-code="sendDialCode"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Country -->
              <!-- <div class="col-sm-6">
                <label>Choose Country</label>
                <app-input
                  type="advance-search-select"
                  :loaded-per-time="10"
                  v-model="input_country"
                  @input="setCountryValue"
                  fetch-url="wilayah/country"
                  placeholder="Choose Country"
                  list-value-field="name"
                  required
                />
              </div> -->
              
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Email <span class="required-star">*</span></label>
                  <app-input
                    type="email"
                    v-model="inquiry[0].parent_email"
                    placeholder="Parent Email"
                    name="parent_email"
                    required
                  />
                </div>
              </div>
              <!-- City -->
              <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                  <label>Area Of Residency <span class="required-star">*</span></label>
                  <app-input
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_city"
                    @input="setCityValue"
                    :fetch-url="`wilayah/city?country_id=${input_country.id}`"
                    placeholder="City"
                    list-value-field="name"
                    required
                  />
                </div>
              </div>
              <!-- Postcode -->
              <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                  <label><br></label>
                  <app-input
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_postcode"
                    @input="setPostCodeValue"
                    :fetch-url="`wilayah/village?city_id=${input_city.id}`"
                    placeholder="Area"
                    list-value-field="full_location"
                    required
                  />
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-lg-12">
                <br>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="container-title-page">
                  <div class="header-title-page">Childs Information</div>
                </div>
              </div>
            </div>

            <template v-for="(child, index) in childs">
              <div class="row" v-if="childs.length > 1" :key="index">
                <!-- separated by line -->
                <div class="col-md-12">
                  <hr class="bold-hr" />
                </div>
                <div class="col-md-12 mb-4 d-flex align-items-center">
                  <div class="col-md-2">
                    <h5 class="font-weight-bold">Child {{ index + 1 }}</h5>
                  </div>
                  <div class="col-md-2">
                    <!-- delete button based on index -->
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm"
                      @click="deleteChild(index)"
                    >
                      <i class="fas fa-trash" style="font-size: 10px"></i>
                      Delete Child Data
                    </button>
                  </div>
                </div>
                <!-- separated by line -->
                <div class="col-md-12">
                  <hr class="bold-hr" />
                </div>
              </div>
              <child-form :key="child.uuid" v-model="childs[index]" />
            </template>

            <div class="row">
              <!-- Add more child -->
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  @click="addChild"
                  :disabled="childs.length >= 3"
                >
                  Add more child
                  <i class="fas fa-plus" style="font-size: 10px"></i>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12"></div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="container-title-page">
                  <div class="header-title-page">CLC Information</div>
                </div>
              </div>
            </div>

            <div class="row">
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                v-if="inquiry[0].marketing_channel.includes(14)"
              >
                <div class="form-group">
                  <label></label>
                  <app-input
                    placeholder="Friend's Name"
                    type="text"
                    name="channel_name"
                    v-model="inquiry[0].channel_name"
                    required
                  />
                </div>
              </div>
              <!-- "How did you hear about us?" -->
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>How did you hear about us? <span class="required-star">*</span></label>
                  <app-input
                    placeholder="How did you hear about us?"
                    type="multi-select"
                    :list="marketingChannelLists"
                    name="marketing_channel"
                    v-model="inquiry[0].marketing_channel"
                    :isAnimatedDropdown="true"
                    required
                  />
                </div>
              </div>
              <!-- Nearest Centre -->
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 parent-nearest">
                <div class="form-group">
                  <label>Nearest CLC</label>
                  <app-input
                    type="search-select"
                    v-model="inquiry[0].center_id"
                    placeholder="Nearest CLC"
                    :list="nearestClcList"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <!-- What time would you like us to contact you? -->
              <div class="col-md-6">
                  <div class="row">
                      <div class="col-md-12">
                          <label>What time would you like us to contact you? <span class="required-star">*</span></label>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <app-input
                            placeholder="What time would you like us to contact you?"
                            type="search-select"
                            :list="contactTimeLists"
                            name="call_times"
                            v-model="inquiry[0].call_times"
                            :isAnimatedDropdown="true"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group" style="padding-top:13px;">
                          <app-input
                            id="input_contact_type"
                            :is-need-name="true"
                            :radio-checkbox-name="`input-contact-type`"
                            type="radio"
                            :list="contactTypeLists"
                            v-model="inquiry[0].contact_type" required
                          />

                        </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Additional Questions</label>
                  <app-input
                    type="text"
                    v-model="inquiry[0].additional_information"
                    name="additional_information"
                    placeholder="Any additional questions"
                  />
                </div>
              </div>
              <!-- "What information are you interested in?" -->
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
								<div class="form-group">
									<label
										>What information are you interested
										in?</label
									>
									<app-input
										placeholder="What information are you interested in?"
										type="search-select"
										:list="learningInterestLists"
										name="learning_interests"
										v-model="inquiry[0].learning_interests"
										:isAnimatedDropdown="true"
										required
									/>
								</div>
							</div>
            </div>
            <!-- <div class="row mt-2"> -->
            <!-- "Any additional information" -->
            <!-- </div> -->

            <div class="row">
              <!-- Subscribe Newsletter -->
              <!-- <div class="col-md-12">
								<div class="form-group">
									<input
										type="checkbox"
										v-model="
											inquiry[0].subscribe_newsletter
										"
										id="subscribe_newsletter"
										required
										name="subscribe_newsletter"
									/>
									<label for="subscribe_newsletter"
										>Yes, I would like to receive
										information about CLC promotions and/or
										events</label
									>
								</div>
							</div> -->
            </div>

            <!-- Submit and Clear button -->
            <div class="mt-5 action-buttons">
              <button
                type="submit"
                class="btn btn-primary mr-2"
                @click.prevent="submit"
              >
                {{ $t("submit") }}
              </button>
              <button
                type="submit"
                class="btn btn-secondary"
                @click.prevent="clear"
              >
                {{ $t("clear") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <InquirySuccessModal
      :show="modalVisible"
      :message="successMessage"
      @close-modal="closeInquirySuccessModal"
    />
  </div>
</template>

<script>
const observer = new MutationObserver(() => {
  document
    .querySelectorAll(".btn.btn-light.btn-sm.btn-block span")
    .forEach((span) => (span.style.display = "none"));
});

// Observasi perubahan dalam body atau elemen dropdown
observer.observe(document.body, { childList: true, subtree: true });

import { InquiryFormMixin } from "./InquiryFormMixin.js";
import GlobalHelperMixin from "../../../Mixins/global/GlobalHelperMixin";
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import InquirySuccessModal from "./InquirySuccessModal";

export default {
  name: "Inquiry",
  mixins: [InquiryFormMixin, GlobalHelperMixin],
  components: { InquirySuccessModal },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          code: "",
          name: "",
          is_active: "",
        };
      },
    },
  },
  data() {
    return {
      preloader: false,
      isLoading: false,
      observer: null,
      urlGenerator,
      inquiryFormBanner: "",
      inquiryFormDescription: "",
      successMessage: "",
      internationalNumber: "628994000065",
      modalVisible: false,
      source_id: 0,
      inquiry: [
        {
          parent_first_name: "",
          parent_last_name: "",
          parent_email: "",
          mobile_number: "",
          mobile_number_dial_code: "62",
          selected_country: "",
          postcode: "",
          city: "",
          call_times: [],
          contact_type: '',
          center_id: "",
          childs: [],
          learning_interests: [],
          marketing_channel: "",
          additional_information: "",
          // subscribe_newsletter: false,
        },
      ],
      childs: [
        {
          uuid: this.uuidv4(),
          selected_country: "",
          child_first_name: "",
          child_last_name: "",
          // child_place_of_birth: "",
          child_date_of_birth: "",
          gender: "",
          // selected_school_name: "",
          school_name: "",
          // selected_school_level: "",
          school_level: "",
          school_name_other:""
        },
      ],
      learningInterestLists: [],
      contactTimeLists: [
        { id: "09.00 - 11.00", value: "09.00 - 11.00" },
        { id: "11.00 - 13.00", value: "11.00 - 13.00" },
        { id: "13.00 - 15.00", value: "13.00 - 15.00" },
        { id: "15.00 - 17.00", value: "15.00 - 17.00" },
        { id: "17.00 - 19.00", value: "17.00 - 19.00" },
      ],
      contactTypeLists: [
          { id: "Call", value: "Call"},
          { id: "Chat", value: "Chat"}
      ],
      marketingChannelLists: [],
      nearestClcList: [],
      input_country: this.value
        ? this.value.country
          ? {
              id: this.value.country.id || 0,
              name: this.value.country.name || "",
              code: this.value.country.code,
              is_active: this.value.country.is_active,
            }
          : {
              id: this.value.country?.id || 0,
              name: this.value.country?.name || "",
              code: this.value.country?.code,
              is_active: this.value.country?.is_active,
            }
        : {
            id: this.value.country.id || 0,
            name: this.value.country.name || "",
            code: this.value.country.code,
            is_active: this.value.country.is_active,
          },
      input_postcode: this.value
        ? this.value
          ? {
              id: this.value.id || 0,
              postal_code: this.value.postal_code || "",
              code: this.value.code,
              is_active: this.value.is_active,
            }
          : {
              id: this.value?.id || 0,
              postal_code: this.value?.postal_code || "",
              code: this.value?.code,
              is_active: this.value?.is_active,
            }
        : {
            id: this.value.id || 0,
            postal_code: this.value.postal_code || "",
            code: this.value.code,
            is_active: this.value.is_active,
          },
      input_city: this.value
        ? this.value
          ? {
              id: this.value.id || 0,
              name: this.value.name || "",
              code: this.value.code,
              is_active: this.value.is_active,
            }
          : {
              id: this.value?.id || 0,
              name: this.value?.name || "",
              code: this.value?.code,
              is_active: this.value?.is_active,
            }
        : {
            id: this.value.id || 0,
            name: this.value.name || "",
            code: this.value.code,
            is_active: this.value.is_active,
          },
    };
  },
  created() {
    
    this.inquiry[0].childs = this.childs;

    // GET Inquiry Form Banner
    axios.get("/get-inquiry-settings").then((response) => {
      this.inquiryFormBanner = response.data.inquiry_form_banner;
      this.inquiryFormDescription = response.data.inquiry_form_description;
    });

    // GET source from URL
    let url = window.location.href;
    this.source_id = url.split("source=")[1];

    // Make an HTTP GET request to the endpoint [GET] /public/marketing-channel
    axios
      .get("/marketing-channel?per_page=50")
      .then((response) => {
        this.marketingChannelLists = response.data.data.map((item) => ({
          id: item.id,
          value: item.name,
        }));

        // If the source_id is not undefined, or 0, then find the source_id and set it as default
        if (this.source_id !== undefined && this.source_id !== "0") {
          const source = this.marketingChannelLists.find(
            (item) => item.id === parseInt(this.source_id)
          );
          if (source) {
            this.inquiry[0].marketing_channel = [source.id];
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    // Make an HTTP GET request to the endpoint [GET] /public/marketing-channel
    axios
      .get("/centers?is_active=true")
      .then((response) => {
        this.nearestClcList = response.data.data.map((item) => ({
          id: item.id,
          value: item.name,
        }));
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    // Make an HTTP GET request to the endpoint [GET] /public/learning-interest
    axios
    	.get("/learning-interest?per_page=50")
    	.then((response) => {
    		response.data.data.forEach((item) => {
    			this.learningInterestLists.push({
    				id: item.id,
    				value: item.name,
    			});
    		});
    	})
    	.catch((error) => {
    		console.error("Error fetching data:", error);
    	});

    // Make an HTTP GET request to the endpoint [GET] /wilaayah/country, then find Indonesia and set it as default
    axios.get("/wilayah/country?per_page=1000").then((response) => {
      const indonesia = response.data.data.find(
        (item) => item.name === "Indonesia"
      );
      if (indonesia) {
        this.input_country = {
          id: indonesia.id,
          name: indonesia.name,
          code: indonesia.code,
          is_active: indonesia.is_active,
        };

        this.inquiry[0].selected_country = indonesia.id;
      }
    });
  },
  mounted() {
    this.observeLoadMoreButton();
    const observer = new MutationObserver(() => {
      this.observeLoadMoreButton();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
  methods: {
    observeLoadMoreButton() {
      setTimeout(() => {
        const dropdowns = document.querySelectorAll(
          ".dropdown-search-result-wrapper"
        );

        dropdowns.forEach((dropdown) => {
          // Hapus event lama untuk mencegah duplikasi
          dropdown.removeEventListener("scroll", this.handleScroll);
          dropdown.addEventListener("scroll", this.handleScroll);
        });
      }, 500);
    },

    handleScroll(event) {
      const dropdown = event.target;

      // Cari tombol di seluruh dokumen jika tidak ditemukan di dropdown
      let loadMoreBtn = dropdown.querySelector(
        ".btn.btn-light.btn-sm.btn-block"
      );
      if (!loadMoreBtn) {
        loadMoreBtn = document.querySelector(".btn.btn-light.btn-sm.btn-block");
      }

      if (!loadMoreBtn || this.isLoading) return;

      const scrollBottom =
        dropdown.scrollTop + dropdown.clientHeight >=
        dropdown.scrollHeight - 10;

      if (scrollBottom) {
        this.isLoading = true;
        loadMoreBtn.click();

        // Pastikan tombol telah diklik dengan benar
        setTimeout(() => {
          this.isLoading = false;
        }, 500); // Sesuaikan delay dengan waktu respons API
      }
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      const isValid = this.$refs.form.reportValidity();
      if (!isValid) {
        return;
      }

      let hasValidationError = false;

      if (this.childs.length >= 1) {
        this.childs.forEach((child) => {
          if (
            child.child_first_name === ""
          ) {
            this.$toastr.e("Please fill in the child's name before submitting the form.");
            hasValidationError = true;
            return;
          }
          
          if (
            child.child_date_of_birth === "" 
          ) {
            this.$toastr.e("Please fill in the child's date of birth before submitting the form.");
            hasValidationError = true;
            return;
          }
          
          if (
            child.gender === "" 
          ) {
            this.$toastr.e("Please fill in the child's gender before submitting the form.");
            hasValidationError = true;
            return;
          }
          
          if (
            child.school_name === "" 
          ) {
            this.$toastr.e("Please fill in the school name before submitting the form.");
            hasValidationError = true;
            return;
          }
          if (
            child.school_level === ""
          ) {
            this.$toastr.e("Please fill in the school level before submitting the form.");
            hasValidationError = true;
            return;
          }
          
          const fullName = (child.child_first_name || '').trim();

          const parts = fullName.split(/\s+/);
          child.child_first_name = parts[0];
          child.child_last_name = parts.slice(1).join(" ") || "";

        });
      }
      // Validation for parent data
      const parent = this.inquiry[0];
      if (parent.city === "") {
        this.$toastr.e("Please fill in the city before submit");
        hasValidationError = true;
      }
      if (parent.postcode === "") {
        this.$toastr.e("Please fill in the postcode before submit");
        hasValidationError = true;
      }
      if (parent.parent_first_name === "") {
        this.$toastr.e("Please fill in the parent full name before submit");
        hasValidationError = true;
      }
      // if (parent.parent_last_name === "") {
      //   this.$toastr.e("Please fill in the parent last name before submit");
      //   hasValidationError = true;
      // }
      if (parent.selected_country === "") {
        this.$toastr.e("Please fill in the country before submit");
        hasValidationError = true;
      }
      if (parent.center_id === "") {
        this.$toastr.e("Please fill in the nearest clc before submit");
        hasValidationError = true;
      }
      if(parent.learning_interests === ""){
      	this.$toastr.e("Please fill in the Learning interests before submit");
      	hasValidationError = true;
      }
      if (parent.marketing_channel === "") {
        this.$toastr.e("Please fill in the marketing channel before submit");
        hasValidationError = true;
      }
      // if(parent.subscribe_newsletter === ""){
      // 	this.$toastr.e("Please fill in the subcribe newsletter before submit");
      // 	hasValidationError = true;
      // }
      // if (
      // 	parent.parent_first_name === "" ||
      // 	parent.parent_last_name === "" ||
      // 	parent.parent_email === "" ||
      // 	parent.mobile_number === "" ||
      // 	parent.selected_country === "" ||
      // 	parent.postcode === "" ||
      // 	parent.city === "" ||
      	// parent.learning_interests.length === 0 ||
      // 	parent.marketing_channel === "" ||
      // 	parent.subscribe_newsletter === false
      // ) {
      // 	this.$toastr.e("Please fill all the data before submit");
      // 	hasValidationError = true;
      // }


      const fullName = (parent.parent_first_name || '').trim();

      const parts = fullName.split(/\s+/);
      parent.parent_first_name = parts[0];
      parent.parent_last_name = parts.slice(1).join(" ") || "";
      
      // Additional validations
      if (
        this.inquiry[0].mobile_number_dial_code !== "62" &&
        this.inquiry[0].mobile_number.length < 5
      ) {
        this.$toastr.e("Mobile number must be at least 9 digits");
        hasValidationError = true;
      }

      // if (
      // 	this.inquiry[0].mobile_number.substring(0, 2) !== "08" &&
      // 	this.inquiry[0].mobile_number.substring(0, 2) !== "62"
      // ) {
      // 	this.$toastr.e(
      // 		"Mobile number must start with 08 or 62 (Indonesia)"
      // 	);
      // 	hasValidationError = true;
      // }

      // Validate the postcode
      // if (this.inquiry[0].postcode.length < 5) {
      // 	this.$toastr.e("Postcode must be at least 5 digits");
      // 	hasValidationError = true;
      // }

      // Validate date of birth
      // this.childs.forEach((child) => {
      // 	const dateOfBirth = new Date(child.child_date_of_birth);
      // 	const today = new Date();
      // 	const age = today.getFullYear() - dateOfBirth.getFullYear();
      // 	const monthDifference =
      // 		today.getMonth() - dateOfBirth.getMonth();

      // 	if (
      // 		monthDifference < 0 ||
      // 		(monthDifference === 0 &&
      // 			today.getDate() < dateOfBirth.getDate())
      // 	) {
      // 		// Adjust the age calculation without modifying the constant
      // 		const adjustedAge = age - 1;

      // 		if (adjustedAge < 3) {
      // 			this.$toastr.e(
      // 				"Child's age must be at least 3 years old"
      // 			);
      // 			hasValidationError = true;
      // 			return;
      // 		}
      // 	} else {
      // 		if (age < 3) {
      // 			this.$toastr.e(
      // 				"Child's age must be at least 3 years old"
      // 			);
      // 			hasValidationError = true;
      // 			return;
      // 		}
      // 	}
      // });

      // If no validation errors occurred, call this.save()
      if (!hasValidationError) {
        // this.inquiry[0].mobile_number =
        // 	this.inquiry[0].mobile_number_dial_code +
        // 	this.inquiry[0].mobile_number;
        this.save(this.inquiry);
      }
    },
    closeInquirySuccessModal() {
      this.modalVisible = false;
      this.clear();
    },
    afterSuccess(res) {
      if(res.data.status == false){
          this.inquiry[0].parent_first_name = this.inquiry[0].parent_first_name +' '+this.inquiry[0].parent_last_name;
          
          if (this.childs.length >= 1) {
            this.childs.forEach((child) => {
              child.child_first_name = child.child_first_name +' '+child.child_last_name;
            });
          }
          Swal.fire({
            text: res.data.message,
            allowOutsideClick: false,
            confirmButtonText: "OK",
          });
      }else{
        const message = `Your CLC Number: ${res.data.message}\n`;
        const whatsappUrl = `https://wa.me/${
          this.internationalNumber
        }?text=${encodeURIComponent(message)}`;

        this.successMessage = `Thank you for submitting your details, <br><a href='${whatsappUrl}' target='_blank'>click here</a> to continue chat with CLC`;
        this.modalVisible = true;
      }
    },
    afterFinalResponse() {
      this.preloader = false;
      this.scrollToTop(false);
    },
    afterError(res) {
      if (res === undefined) {
        return;
      } else if (res.data === undefined) {
        return;
      } else if (res.data.message === undefined) {
        return;
      } else {
        Swal.fire({
          title: "Error!",
          text: res.data.message,
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "OK",
        });
      }
    },
    clear() {
      this.inquiry = [
        {
          parent_first_name: "",
          parent_last_name: "",
          parent_email: "",
          mobile_number: "",
          selected_country: "",
          postcode: "",
          city: "",
          childs: [],
          learning_interests: [],
          marketing_channel: "",
          additional_information: "",
          // subscribe_newsletter: false,
        },
      ];
      this.childs = [
        {
          uuid: this.uuidv4(),
          selected_country: "",
          child_first_name: "",
          child_last_name: "",
          // child_place_of_birth: "",
          child_date_of_birth: "",
          gender: "",
          school_name: "",
          school_level: "",
          school_name_other: "",
        },
      ];
      this.fieldStatus = {
        isSubmit: false,
      };
      this.input_country = {
        id: undefined,
        name: "",
        code: "",
        is_active: "",
      };
      this.input_postcode = {
        id: undefined,
        code: "",
        postal_code: "",
        is_active: "",
      };
      this.input_city = {
        country_id: undefined,
        city_id: undefined,
        code: "",
        name: "",
        is_active: "",
        city: {
          id: undefined,
          code: "",
          name: "",
          is_active: "",
        },
      };
    },
    addChild() {
      this.childs.push({
        uuid: this.uuidv4(),
        selected_country: "",
        child_first_name: "",
        child_last_name: "",
        // child_place_of_birth: "",
        child_date_of_birth: "",
        gender: "",
        school_name: "",
        school_level: "",
        school_name_other:""
      });
    },
    deleteChild(index) {
      this.childs.splice(index, 1);
    },
    updateChilds() {
      this.inquiry[0].childs = this.childs;
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    resetPostCode() {
      this.input_postcode = {
        id: undefined,
        code: "",
        postal_code: "",
        is_active: "",
      };
    },
    resetCity() {
      this.input_city = {
        country_id: undefined,
        city_id: undefined,
        code: "",
        name: "",
        is_active: "",
        city: {
          id: undefined,
          code: "",
          name: "",
          is_active: "",
        },
      };
    },
    setCountryValue(data) {
      this.inquiry[0].selected_country = this.inquiry[0].selected_country;
      if (data && data.hasOwnProperty("id")) {
        this.inquiry[0].selected_country = data.id;
        this.resetCity();
      }
    },
    setCityValue(data) {
      this.inquiry[0].city = this.inquiry[0].city;
      if (data && data.hasOwnProperty("name")) {
        this.inquiry[0].city = data.name;
        this.resetPostCode();
      }
    },
    setPostCodeValue(data) {
      this.inquiry[0].postcode = this.inquiry[0].postcode;
      if (data && data.hasOwnProperty("id")) {
        this.inquiry[0].postcode = data.id;
      }
    },
    sendDialCode(dialCode) {
      this.inquiry[0].mobile_number_dial_code = dialCode;
    },
  },
  watch: {
    inquiry: {
      handler: function (val) {
        // this.updateChilds();
        this.childs.forEach((child) => {
          child.selected_country = val[0].selected_country;
        });
      },
      deep: true,
    },
    childs: {
      handler: function (val) {
        this.updateChilds();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* Style for required asterisk */
.required-star {
  color: red;
}
.mt-4 {
  margin-top: 4rem !important;
}
.mt-2 {
  margin-top: 2rem !important;
}
.bold-hr {
  border-top: 2px solid #000; /* You can adjust the color and thickness as needed */
}
.card {
  box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
.banner {
  /* background-size: cover; /* Resize the background image to cover the entire container */
  background-size: contain; /* Resize the background image to contain the entire image within the container */
  /* background-size: 100% auto; /* 100% width and height, but constrain proportions */
  /* background-size: 100% 100%; /* 100% width and height, no constraint */
  /* background-size: 100% 100%; */
  background-repeat: no-repeat; /* Prevent image repetition */
  background-position: center; /* Center the image */
}
.logo-image {
  width: 30%;
}
::v-deep .chips-container {
  min-height: 44px !important;
  background-color: #fff !important;
  border: 1px solid #686868 !important;
}

::v-deep(.card-content) {
  margin-top: 1dvw;
  width: 60dvw;
}
::v-deep(.banner) {
  width: 100%;
  margin-bottom: 20px;
}

::v-deep(.col-lg-6) {
  flex: 0 0 50%;
  max-width: 50%;
}

::v-deep(.text-inquiry-form) {
  font-weight: 600;
  color: #376971;
}
@media (max-width: 700px) {
  :deep(.card-content) {
    width: auto;
  }
  :deep(.mb-primary) {
    padding: 0 !important;
  }
  :deep(.vue-tel-input .vti__dropdown) {
    padding: 10px 1px !important;
  }
  :deep(.parent-nearest) {
    margin-top: 20px;
  }
  :deep(.logo-image) {
    width: 44%;
  }
  :deep(.text-inquiry-form) {
    font-size: 1.6rem;
    font-weight: 600;
    color: #006a7b;
  }
}
::v-deep(.header-title-page) {
  background-color: #ffeb3b; /* warna kuning */
  display: inline-block;
  padding: 3px 17px 0px 8px;
  font-family: Arial, sans-serif;
  position: relative;
  border-radius: 0px 0px 57px 0px;
  font-size: 18px;
  font-weight: 600;
}

::v-deep(.header-title-page::after) {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
}

::v-deep(.container-title-page) {
  border-bottom: 2px solid #ffeb3b;
  margin-bottom: 10px;
}
</style>
